export { default } from "./BookingFeeTemplate"